import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SEO from './components/SEO';
import LandingPage from './LandingPage';
import AboutAcademy from './AboutAcademy';
import AboutDonzi from './AboutDonzi';
import InternationalExhibitions from './InternationalExhibitions';
import AnnualExhibitions from './AnnualExhibitions';
import RegistrationPage from './RegistrationPage';
import ExhibitionDetail from './ExhibitionDetail';
import GlobalEgyptianYouth from './GlobalEgyptianYouth';

function App() {
  return (
    <Router>
      <div className="min-h-screen w-full flex flex-col">
        <SEO
          title="Home"
          description="Welcome to Donzi Art Academy - A premier art education center for children. Explore our exhibitions, art classes, workshops, and programs designed to nurture creativity and artistic expression."
          keywords="art, academy, exhibitions, Donzi, Donzi Art Academy, kids, children, art classes, art workshops, art activities, art programs, art courses, art lessons, art classes for kids, art workshops for kids, art activities for kids, art programs for kids, art courses for kids, art lessons for kids"
        />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutAcademy />} />
            <Route path="/donzi" element={<AboutDonzi />} />
            <Route path="/exhibitions" element={<InternationalExhibitions />} />
            <Route path="/exhibition/:type/:id" element={<ExhibitionDetail />} />
            <Route path="/global-egyptian-youth" element={<GlobalEgyptianYouth />} />
            <Route path="/register" element={<RegistrationPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;